import { TypePolicies } from '@apollo/client'

export const costCentersTypePolicies: TypePolicies = {
  // Use composite key to uniquely identify CostCentersStructuredCostCenter objects.
  // - Real cost centers: id is unique, structure is null
  // - Job catalog nodes: id + structure combination is unique
  CostCentersStructuredCostCenter: {
    keyFields: ['id', 'structure'],
  },
}
